import { memo } from 'react'
import { isLounge } from '../../../../mfcLogic/userProperties/user'
import { useUserSelector } from '../../../Hooks/useUser'
import LoungeChatHeader from './LoungeChatHeader'
import OfflineChatHeader from './OfflineChatHeader'
import OnlineChatHeader, { OnlineChatHeaderProps } from './OnlineChatHeader'

const ChatHeader = memo((props: OnlineChatHeaderProps) => {
    const { id, pm } = props
    const slug = useUserSelector(id, 'slug')
    const isModel = useUserSelector(id, 'isModel')
    const isOffline = useUserSelector(id, 'isOffline')
    const isBroadcasting = useUserSelector(id, 'isBroadcasting')

    const lounge = isLounge(slug)

    if (lounge) {
        return <LoungeChatHeader {...props} />
    }

    if (pm && (isOffline || !isBroadcasting || !isModel)) {
        return <OfflineChatHeader {...props} />
    }

    return <OnlineChatHeader {...props} />
})

export default ChatHeader
